import { Common, Spacing } from "@bonusx-global/bx-design-system";
import { PREVIOUS_URL_PATH, WELCOME_PATH } from "../../../../../constants/env";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import { headerHeight } from "../../../../../R";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class UnauthenticatedRouteWithBackButtonVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return false;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      layoutStyles: {
        mobile: { backgroundColor: Common.white.main },
        desktop: {
          backgroundColor: Common.white.main,
          height: "100vh !important",
        },
      },
      contentLayoutStyles: {
        mobile: {
          height: `calc(100vh - ${headerHeight})`,
          paddingBottom: `${Spacing["2500"]} !important`,
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: WELCOME_PATH,
        },
        actions: [],
        showLogo: true,
        showLogoOnMobile: true,
        forceLogoExtended: true,
      },
    };
  }
}
